module.exports = __webpack_public_path__ + "img/icon_sec2_2@2x.97b116fa.png";